import React, { Component } from 'react';
import querystring from 'query-string';
import paybillMap from './config'
import { getQueryVariable } from '@/utils/utils';
import '@/assets/css/MPESARepaymentSteps.scss';

class MPESARepaymentSteps extends Component {
  constructor(props) {
    super(props);
    this.state = {
      app: '',
      paybillMap: '',
      mobile:'',
    }
  }
  getQueryParam(){
    let string = this.props.location.search
    return querystring.parse(string)
  }
  handleSupportPhoneClick(e){
    if (!window.android) return

    window.android.trackEvent('h5_mpesa_hotline_click', null)
    window.android.dialHotLine()
  }
  handleSupportMailClick(e){
    if (!window.android) return

    window.android.trackEvent('h5_mpesa_email_click', null)
    window.android.sendSupportEmail()
  }
  setInfo(){
    const app = getQueryVariable('app')
    const appName = (app || '').toLowerCase()
    // 兼容小写
    this.setState({
      app: appName,
      paybillNumber: paybillMap[appName],
    })
  }
  setUserMobilePhone(){
    if (!window.android) return

    let mobile = window.android.getUserMobile()
    this.setState({
      mobile: mobile,
    })
  }
  componentDidMount(){
    document.title = 'MPESA Repayment Steps'
    this.setInfo()
    this.setUserMobilePhone()
    window.android && window.android.trackEvent('h5_mpesarepaymentsteps_open', null)
  }
  render() {
    const { mobile, paybillNumber, app } = this.state

    const appClass = 'repayment-steps ' + app
    return <div className={appClass}>
      <div className='content'>
        <div className='title'> Follow Below Steps </div>
        <div>
          <p>1. Navigate to MPesa in your Safaricom menu on your phone</p>
          <p>2. Select Lipa na M-PESA</p>
          <p>3. Choose the Paybill option</p>
          <p>4. Enter the Paybill number <span className='number'>{paybillNumber}</span></p>
          <p>5. For account number, enter <span className='number'>{mobile || 'your phone number'}</span> which received your loan</p>
          <p>6. Enter your repayment amount</p>
          <p>7. Enter your M-PESA pin</p>
          <p>8. Confirm that all details are correct and press "OK".</p>
        </div>
      </div>
      <div className='foot_support'>
        <p>Need more help for repayment?</p>
        <p>
          Click <span className='link' onClick={this.handleSupportPhoneClick}>Support Hotline</span> and <span className='link' onClick={this.handleSupportMailClick}>Support Email</span>
        </p>
      </div>
    </div>
  }
}

export default MPESARepaymentSteps;
